import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sortGroupedMenus',
  pure: false
})
export class SortGroupedMenusPipe implements PipeTransform {

  transform(groupedMenus: { available_date: Date, menu_id: number, name: string, menu_count: number, vegetarian: boolean, low_carb: boolean, special: boolean }[]): { available_date: Date, menu_id: number, name: string, menu_count: number, vegetarian: boolean, low_carb: boolean, special: boolean }[] {
    return groupedMenus.sort((a, b) => {
      if (a.available_date != b.available_date)
        return a.available_date < b.available_date ? -1 : (a.available_date > b.available_date ? 1 : 0);
      else
        return a.menu_id < b.menu_id ? -1 : (a.menu_id > b.menu_id ? 1 : 0);
    });
  }

}
